import { type PropsWithChildren } from 'react';

export const SimpleCommentList = ({ children }: PropsWithChildren) => <ul>{children}</ul>;
